<template>
  <div class="company">
    <div id="company-banner"></div>
    <Introduction />
    <Honor />
    <History />
    <Idea />
    <Responsibility />
    <HomeFooter />
  </div>
</template>

<script>
import HomeFooter from "../home/components/footer";
import Introduction from "./components/Introduction";
import Honor from "./components/honor";
import History from "./components/history";
import Idea from "./components/idea";
import Responsibility from "./components/responsibility";
export default {
  name: "app",
  components: {
    HomeFooter,
    Introduction,
    Honor,
    History,
    Idea,
    Responsibility
  }
};
</script>

<style lang="scss" scoped>
#company-banner {
  background: url(~@/assets/images/new-img/company/banner.png) no-repeat center top;
  height: 300px;
}
</style>
